import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import BaseButton from "src/atoms/Button/BaseButton";

const PriceInfoWrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.space[1]}px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.colors.semantic.red};
  align-items: center;
`;
const Button = styled(BaseButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 12px;
  width: 12px;
  margin-left: ${({ theme }) => theme.space[2]}px;
`;

const NoteWrapper = styled(Flex)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.tone.sand};
  border-radius: 8px;
  padding: ${({ theme }) => theme.space[3]}px;
  width: 100%;
`;

export { Button, NoteWrapper, PriceInfoWrapper };
